module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-19-1f9f106221c8fcc55ec177a86c180860.jpg";